import {
  Paper,
  Typography,
  Button,
  TableContainer,
  CircularProgress,
  TableHead,
  TableRow,
  TableCell,
  useTheme,
} from "@mui/material";
import {  MouseEvent } from "react";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import { insuranceClaimSummaryReport, insuranceClaimSummaryReportExcel, insuranceClaimSummaryReportPdf } from "../services";

function InsuranceClaimSummary() {
  const theme = useTheme()
  const { control, reset, getValues } = useForm();
  const {
    mutate: getTableData,
    data: tableData,
    isLoading: tableDataLoading,
    reset: resetMutation,
  } = useMutation(insuranceClaimSummaryReport);

  const { mutate: getPdfFile, isLoading: pdfLoading } =
    useRepotFile({
      apiFunction: insuranceClaimSummaryReportPdf,
      responseFileKey:"file",
    });
    const { mutate: getExcelFile, isLoading: excelLoading } =
      useRepotFile({
        apiFunction: insuranceClaimSummaryReportExcel,
        fileType: "xlsx",
        // responseFileKey: "file",
      });

  const onChange = () => {
    const data = getValues();
    if (data?.fromDate && data?.toDate) {
      getTableData(data as { fromDate: string; toDate: string });
    }else{
      resetMutation()
    }
  };

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: "",
    });
    resetMutation();
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getPdfFile({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
    else {
      getExcelFile({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
          Insurance Claim Summary Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 pt-3 px-2 pb-2"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "TO Date is required", onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
            type="submit"
            disabled={tableDataLoading}
            endIcon={tableDataLoading && <CircularProgress size={18} />}
          >
            search
          </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              pdfLoading || !Boolean(tableData?.response?.length)
            }
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          <Button
          disabled={excelLoading || !Boolean(tableData?.response?.length)}
          endIcon={excelLoading && <CircularProgress size={18} />}
          data-filetype="excel"
          onClick={getFiles}
        >
          excel
        </Button>
        </div>
        <TableComponent
          CustomHeader={
            <TableHead>
                <TableRow>
                   <TableCell sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>Sl no </TableCell>
                   <TableCell sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>Insurance Name</TableCell>
                  <TableCell align="center" colSpan={2} sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>TOTAL CLAIMS</TableCell>
                  <TableCell align="center" colSpan={2} sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>REJECTED</TableCell>
                  <TableCell align="center" colSpan={2} sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>APPROVED</TableCell>
                  <TableCell align="center" colSpan={2} sx={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}}>NOT SUBMITTED</TableCell>
                </TableRow>
                <TableRow>
                   <TableCell colSpan={2}></TableCell>
                  <TableCell align="center">Count</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Count</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Count</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Count</TableCell>
                  <TableCell align="center">Amount</TableCell>
                </TableRow>

            </TableHead>
          }
          align="center"
          loading={tableDataLoading}
          data={tableData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
}

export default InsuranceClaimSummary;

const heading = [
  { heading: "Insurance Name", key: "insuranceName" },
  { heading: "Total claims", key: "totclaims" },
  { heading: "Total claimed", key: "totclaimed" },
  { heading: "Total rejected claims", key: "totRejClaims" },
  { heading: "Total rejected", key: "totRej" },
  { heading: "Total approved claims", key: "totApprovedClaims" },
  { heading: "Total approved", key: "totApproved" },
  { heading: "Not submitted", key: "notSubCount" },
  { heading: "Not submitted amount", key: "notSubAmount" },
];

